import React, { Fragment, ReactNode } from "react";
import { FormattedMessage } from "react-intl";

export type Props = {
  isAdmin: boolean;
  displayMsg?: boolean;
  children: ReactNode;
};

const AdminOnly = ({
  displayMsg = false,
  isAdmin = false,
  children,
}: AdminOnlyProps) => {
  if (isAdmin) {
    return <Fragment>{children}</Fragment>;
  }

  if (displayMsg) {
    return <FormattedMessage id="segments.admin_only" />;
  }

  return null;
};

export default AdminOnly;
export type AdminOnlyProps = Props;
